import React from 'react';
import { SelectDroneProps } from './types';
import { OrderIdParams } from '@src/core/entities';
import { useParams } from 'react-router-dom';
import { useGetOrderQuery } from '@src/features/order/redux';
import { ArcDroneMarker, ArcPolyline, DestinationMarker, DistanceLabel } from '@src/core/controllers';
import { useSelector } from 'react-redux';
import { selectDrone, selectHoveredDrone } from '@src/features/order/pages/upsert-mission-page/redux';
import { DroneStatusType, useDroneProvider } from '@src/core/features';

const SelectDroneMap: React.FC<SelectDroneProps> = () => {

  const selected = useSelector(selectDrone);
  const hovered = useSelector(selectHoveredDrone);
  const params = useParams<OrderIdParams>();
  const { data, isLoading } = useGetOrderQuery(params.orderId);
  const { drones, isLoading: isDroneLoading } = useDroneProvider(DroneStatusType.IDLE);

  const droneLat = Number(selected?.latitude);
  const droneLng = Number(selected?.longitude);

  const destinationLat = Number(data?.destinationLocation?.latitude);
  const destinationLng = Number(data?.destinationLocation?.longitude);

  if (isLoading || isDroneLoading) return null;

  return (
    <React.Fragment>
      <DestinationMarker.pending 
        position={{ 
          lat: destinationLat, 
          lng: destinationLng, 
        }} />

      {drones.map((drone) => {

        if (drone.id === hovered?.id) {
          return (
            <ArcDroneMarker.idleSelected 
              key={drone.id} 
              position={{ 
                lat: Number(drone.latitude), 
                lng: Number(drone.longitude),
              }} />
          );
        }

        if (drone.id === selected?.id) {
          return (
            <ArcDroneMarker.idleSelected 
              key={drone.id} 
              position={{ 
                lat: Number(drone.latitude), 
                lng: Number(drone.longitude),
              }} />
          );
        }

        return ( 
          <ArcDroneMarker.idleArrow 
            key={drone.id}
            position={{ 
              lat: Number(drone.latitude), 
              lng: Number(drone.longitude),
            }}  
          />
        );
      })}

      {isNaN(droneLat) || isNaN(droneLng) 
        ? null 
        : <ArcPolyline.future 
          path={[
            { lat: droneLat, lng: droneLng },
            { lat: destinationLat, lng: destinationLng },
          ]} 
        />}

      {isNaN(droneLat) || isNaN(droneLng) 
        ? null 
        : <DistanceLabel 
          path={[
            { lat: droneLat, lng: droneLng },
            { lat: destinationLat, lng: destinationLng },
          ]} 
        />}
      
    </React.Fragment>
  );
};


export default SelectDroneMap;